export default {
  // global actions
}